import React, { FC, ReactNode } from 'react';
import cx from 'classnames';
import Text, { TextSize } from '@move-ui/text';
import { useTranslation } from '../../utils/translations';
import Icon, { MenuIcon } from '../Icon';
import styles from './MenuItemLabel.css';

type Props = {
  icon?: string | MenuIcon | ReactNode;
  isBadgeVisible?: boolean;
  text: string;
  username?: string;
};

const MenuItemLabel: FC<Props> = ({
  icon,
  isBadgeVisible,
  text,
  username
}): JSX.Element => {
  const { translate } = useTranslation();

  const shouldShowUsername = text.split('|').includes('username');

  return (
    <>
      {icon && (
        <Icon
          badge={isBadgeVisible}
          className={cx({
            [styles.icon]: icon !== 'User',
            [styles.userIcon]: icon === 'User'
          })}
          icon={icon}
        />
      )}
      <Text bold className={styles.text} color="neutral-100" size={TextSize.M}>
        <span className={styles.labels}>
          {text.split('|').map((line) =>
            line === 'username' ? (
              <span key={line} className={styles.label}>
                {username}
              </span>
            ) : (
              <span
                key={line}
                className={cx(styles.label, {
                  [styles.branded]: shouldShowUsername
                })}
              >
                {translate(line)}
              </span>
            )
          )}
        </span>
      </Text>
    </>
  );
};

export default MenuItemLabel;
